import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import IncidentTypesOverTimeChart from './IncidentTypesOverTimeChart';
import IncidentVolumeByHourChart from './IncidentVolumeByHourChart';
import IncidentTypeDistributionChart from './IncidentTypeDistributionChart';
import IncidentByUnitChart from './IncidentByUnitChart';
import AverageResponseTimesOverTime from './AverageResponseTimesOverTime';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { getIncidentsOverview } from '../../store/incidentsPerformanceReducer';
import { useSelector } from 'react-redux';
import FilterOverview from '../../components/Incidents/FilterOverview';
import { getDepartmentsList } from '../../store/incidentsReducer';
import { getFilterParams } from '../../components/Incidents/FilterOverview/useFiltersUrlState';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment/moment';

const CustomBox = styled(Box)(({ theme }) => ({
  '&.MuiBox-root': {
    padding: '16px',
    border: '1px solid #E1E1E1',
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '20px',
    paddingLeft: '16px',
    borderRadius: '8px',
    '& h5': {
      fontSize: '20px',
      fontWeight: 700,
      marginBottom: '16px',
    },
  },
}));

const Performance = () => {
  const dispatch = useDispatch();

  let { chartsData, loading } = useSelector(
    (state) => state.incidentsPerformanceReducer
  );

  // init fetch
  useEffect(() => {
    const params = getFilterParams();
    dispatch(
      getIncidentsOverview({
        ...params,
      })
    );
    dispatch(getDepartmentsList());
  }, [dispatch]);

  return (
    <Box>
      <Card
        className="p-3 mt-4"
        sx={{
          boxShadow: '0px 4px 4px 0px #0000000F',
        }}
      >
        <CardContent className="p-0">
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3,
            }}
          >
            <Typography
              variant="h5"
              className="mb-2 mb-3"
              sx={{ fontWeight: 700 }}
            >
              Performance
            </Typography>
            <FilterOverview />
          </Stack>

          {loading ? (
            <Box
              sx={{ minHeight: '100px' }}
              className="w-100 h-100 d-flex justify-content-center align-items-center"
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2} className="my-2">
              <Grid item xs={12} lg={6}>
                <CustomBox>
                  <Typography variant="h5">Incident Types Over Time</Typography>
                  <IncidentTypesOverTimeChart data={chartsData.incidents} />
                </CustomBox>
              </Grid>
              <Grid item xs={12} lg={6}>
                <CustomBox>
                  <Typography variant="h5">
                    Incident Volume by Hour of Day
                  </Typography>
                  <IncidentVolumeByHourChart data={chartsData.hours} />
                </CustomBox>
              </Grid>
              <Grid item xs={12} lg={6}>
                <CustomBox>
                  <Typography variant="h5">
                    Incident Type Distribution
                  </Typography>
                  <IncidentTypeDistributionChart data={chartsData.types} />
                </CustomBox>
              </Grid>
              <Grid item xs={12} lg={6}>
                <CustomBox>
                  <Typography variant="h5">
                    Incident by Unit/Apparatus
                  </Typography>
                  <IncidentByUnitChart data={chartsData.unitResponses} />
                </CustomBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <CustomBox>
                  <Typography variant="h5">
                    Average response times over time
                  </Typography>
                  <AverageResponseTimesOverTime data={chartsData.dayNight} />
                </CustomBox>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Performance;
